import React from 'react'

import serverData, { init as initServerData } from '../utils/server-data'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'

import ErrorBoundary from '../components/errorBoundary'

initServerData()

const RootProvider: React.FunctionComponent<{}> = ({
  children,
}: {
  children: JSX.Element
}) => {
  return (
    <ErrorBoundary>
      <WorldReadyContextProvider locale={serverData.locality.locale}>
        {children}
      </WorldReadyContextProvider>
    </ErrorBoundary>
  )
}

export default RootProvider
